import React, { Component } from "react";
import { PiPlus } from "react-icons/pi";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import {
	FormControl,
	Button,
	InputGroup,
	Dropdown,
	Tabs,
	Tab,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import axios from '../../axios';
import apiError from '../../error';
import Users from '../../component/iam/users';
import Roles from '../../component/iam/roles';

// import "./department.css";
import { getCookie } from '../../function';

export default class IAM extends Component {
	constructor(props) {
		super(props);
		this.isTAconnected = getCookie("isTAconnected");
		this.isTASyncing = getCookie("isTASyncing");
		this.state = {
			count: 0,
			limit: 10,
			search: '',
			groups: [],
			activePage: 1,
			loading: true,
			syncLoading: false,
			showHierarchy: false,
			show: false,
			searchshowmodal: false,
			password: '',
			adModal: false,
			adLoading: false,
			showAdPassword: false,
			adGroups: [],
			groupModal: false,
			gsuiteModal: false,
			azureModal: false,
			permissibleActionsIAM: {},
			activeTab: "iam-users",
			selectedTargets: [],
			customGroupName: "",
			selectedGroupId: "",
			remainingUsersLimit: null,
			licenseExpiredAt: "",
			selectedGroupType: "custom",
			isFromTAsyncing: false,
			fromTAsyncCompleted: false,
			toBeSyncedFromTA: false,
			showLimitInLabel: false,
            createUsersShow: false,
            createRolesShow: false,
			roleFilterId: "",
			roleOptions: [],
			userStatusFilter: "",
		}
	}

	componentDidMount() {
		this.fetchRoleOptions();
	}

	fetchRoleOptions = () => {
		axios
			.get("/api/roles", { params: { limit: 500, page: 1, search: "" } })
			.then((res) => {
				this.setState({ roleOptions: res.data.roles || [] });
			})
			.catch(() => {
				this.setState({ roleOptions: [] });
			});
	};

	getRoleFilterLabel = () => {
		if (!this.state.roleFilterId) return "Role";
		const id = String(this.state.roleFilterId);
		const role = this.state.roleOptions.find((r) => String(r.id) === id);
		return role ? role.name : "All";
	};

	getUserStatusFilterLabel = () => {
		const v = this.state.userStatusFilter;
		if (v === "verified") return "Verified";
		if (v === "pending") return "Pending";
		return "Status";
	};

    handleSelect = (selectedTab) => {
        this.setState({ activeTab: selectedTab });
    }

    handleAddUser = () => {
        this.setState({ activeTab: "iam-users", createUsersShow: true });
        // this.load();
    }

    handleAddRole = () => {
        this.setState({ activeTab: "roles", createRolesShow: true });
    }

	handleRedirectToTAAddUser = async () => {
		try {
			const response = await axios.post("/api/redirect/", {
				urlName: "addIAMUser",
			});
			window.location.replace(`${response.data.url}?appName=TSAT&action=iam`);
		} catch (error) {
			apiError(error);
		}
	};

    handleCreateRolesModal = () => {
        this.setState({ createRolesShow: false });
    }

    handleCreateUsersModal = () => {
        this.setState({ createUsersShow: false });
    }

	render() {
		return (
			<>
				<div className="content-wrap">
					<div className="breadcrumbbar">
						<div className="flexRow row">
							<div className={`col-md-4`} style={{ textAlign: 'left', paddingLeft: 0 }}>
								<div className="page-head d-flex align-items-center justify-content-between">
									<h4 className="page-title" >Identity and Access Management</h4>
								</div>
							</div>

							<div className={"col-md-8 flexFilterButtons"}>
								<div className="btn-container float-right d-flex align-items-center">
									{this.state.activeTab === "iam-users" ? (
										<OverlayTrigger
											placement="top"
											overlay={
												this.isTASyncing ? (
													<Tooltip id="iam-add-user-sync-tip">
														<span>Threatcop Admin Sync is already in progress</span>
													</Tooltip>
												) : (
													<Tooltip id="iam-add-user-no-tip" className="d-none" />
												)
											}
										>
											<Button
												style={{ marginRight: "6px" }}
												variant="primary"
												className={`btn-with-icon ${this.isTASyncing ? "disabledCls2" : ""}`}
												onClick={
													this.isTAconnected
														? !this.isTASyncing
															? this.handleRedirectToTAAddUser
															: undefined
														: !this.isTASyncing
															? this.handleAddUser
															: undefined
												}
											>
												<PiPlus /> Add User
											</Button>
										</OverlayTrigger>
									) : (
										!this.isTAconnected && (
											<OverlayTrigger
												placement="top"
												overlay={
													this.isTASyncing ? (
														<Tooltip id="iam-create-role-sync-tip">
															<span>Threatcop Admin Sync is already in progress</span>
														</Tooltip>
													) : (
														<Tooltip id="iam-create-role-no-tip" className="d-none" />
													)
												}
											>
												<Button
													style={{ marginRight: "6px" }}
													variant="primary"
													className={`btn-with-icon ${this.isTASyncing ? "disabledCls2" : ""}`}
													onClick={!this.isTASyncing ? this.handleAddRole : undefined}
												>
													<PiPlus /> Create Role
												</Button>
											</OverlayTrigger>
										)
									)}

								</div>
							</div>
						</div>
					</div>

							<div className="contentbar">
								<div className="filter-without-border">
									<div className="align-items-center row" id="tab-wrapper">
										<div className="col-md-3 hide-tab-content">
											<Tabs
												activeKey={this.state.activeTab}
												onSelect={this.handleSelect}
												id="controlled-tab-example"
												className="groupTab p-0 "
											>
												<Tab eventKey="iam-users" title="IAM Users " />
												<Tab eventKey="roles" title="Roles" />
											</Tabs>
										</div>

										<div className="col-sm-9">
											<div className="rightFilters">
												<div className="positionSearchIcon">
													<InputGroup>
														<FormControl
															type="text"
															placeholder="Search"
															value={this.state.search}
															className="inputSearch mr-sm-2 form-control"
															onChange={(e) =>
																this.setState(
																	{ search: e.target.value, activePage: 1 }
																)
															}
														/>
														<SearchSharpIcon className="search-icon"></SearchSharpIcon>
													</InputGroup>
												</div>
												{this.state.activeTab === "iam-users" && (
													<>
														<Dropdown className="d-inline-block">
															<Dropdown.Toggle variant="secondary" id="iam-role-filter" className="dropdown-color-white mr-2">
																{this.getRoleFilterLabel()}
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item
																	key="role-all"
																	onClick={() => this.setState({ roleFilterId: "" })}
																	active={!this.state.roleFilterId}
																>
																	All
																</Dropdown.Item>
																{this.state.roleOptions.map((role) => (
																	<Dropdown.Item
																		key={`role-${role.id}`}
																		onClick={() =>
																			this.setState({ roleFilterId: String(role.id) })
																		}
																		active={String(this.state.roleFilterId) === String(role.id)}
																	>
																		{role.name}
																	</Dropdown.Item>
																))}
															</Dropdown.Menu>
														</Dropdown>
														<Dropdown className="d-inline-block">
															<Dropdown.Toggle variant="secondary" id="iam-user-status-filter" className="dropdown-color-white mr-2">
																{this.getUserStatusFilterLabel()}
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item
																	key="status-all"
																	onClick={() => this.setState({ userStatusFilter: "" })}
																	active={!this.state.userStatusFilter}
																>
																	All
																</Dropdown.Item>
																<Dropdown.Item
																	key="status-verified"
																	onClick={() => this.setState({ userStatusFilter: "verified" })}
																	active={this.state.userStatusFilter === "verified"}
																>
																	Verified
																</Dropdown.Item>
																<Dropdown.Item
																	key="status-pending"
																	onClick={() => this.setState({ userStatusFilter: "pending" })}
																	active={this.state.userStatusFilter === "pending"}
																>
																	Pending
																</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
													</>
												)}

											</div>
										</div>
									</div>
								</div>
                                {
                                    this.state.activeTab === "iam-users" ? 
                                    <Users
                                    createUsersShow={this.state.createUsersShow}
                                    handleModal={this.handleCreateUsersModal}
									search={this.state.search}
									limit={this.state.limit}
									roleFilterId={this.state.roleFilterId}
									statusFilter={this.state.userStatusFilter}
                                     /> : 
                                    <Roles
                                        createRolesShow={this.state.createRolesShow}
                                        handleCreateRolesModal={this.handleCreateRolesModal}
										search={this.state.search}
										limit={this.state.limit}
                                    />
                                }
							</div>
				</div>
			</>
		);
	}
}